import { OBDropdown, Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

interface IProps {
  title: string | JSX.Element
  items: { text: string | JSX.Element; onClick?: () => void; disabled?: boolean }[]
  suppress?: boolean
  tooltipText?: string | JSX.Element
}

export const LabelDropdown = ({ title, items, suppress, tooltipText }: IProps) => {
  return (
    <Div>
      <OBDropdown
        disableMenuPortal={true}
        className="dropdown-container"
        variant="primary"
        radius="rounded"
        buttonName={
          <Tooltip
            suppress={suppress}
            className="text-with-tooltip"
            tooltipText={suppress ? ''! : tooltipText!}
            position={PositionEnum.top}
            positionContent={-60}
            positionTooltipArrow={100}
            tooltipStyles={{
              'max-width': '31rem !important',
              width: '31rem !important',
              zIndex: 101,
              transform: 'translateX(-35%)',
            }}
          >
            <span>{title}</span>
          </Tooltip>
        }
        items={[
          {
            items: items.map((item) => ({
              text: item.text,
              onClick: item.onClick ?? (() => undefined),
              disabled: item.disabled,
            })),
          },
        ]}
      />
    </Div>
  )
}

const Div = styled.div`
  .dropdown-container #dropdown-basic {
    height: 32px;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 12px;
    border-radius: 8px;
    font-family: Milliard;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    border: solid 1px ${({ theme }) => theme.colors.error.lighter};
    background-color: ${({ theme }) => theme.colors.error.lightest};
    color: ${({ theme }) => theme.colors.error.darker};
    box-shadow: none;
  }
  .btn-check:active + .btn-primary,
  .btn-check:checked + .btn-primary,
  .btn-primary.active,
  .btn-primary:active,
  .show > .btn-primary.dropdown-toggle,
  .dropdown-container .dropdown-toggle:active,
  .dropdown-container .dropdown-toggle:focus,
  .dropdown-container .dropdown-toggle:hover {
    border: solid 1px ${({ theme }) => theme.colors.error.lighter};
    background-color: ${({ theme }) => theme.colors.error.lightest};
    color: ${({ theme }) => theme.colors.error.darker};
    box-shadow: none;
  }
  .dropdown-item.active,
  .dropdown-item:active {
    background-color: ${({ theme }) => theme.colors.grey.lighter};
    color: ${({ theme }) => theme.colors.grey.darker};
  }
  .dropdown-container {
    .dropdown-menu {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: left;
      color: ${({ theme }) => theme.colors.neutral.neutral};
      border-radius: 8px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
      border: solid 1px ${({ theme }) => theme.colors.grey.lighter};
      background-color: ${({ theme }) => theme.colors.neutral.lightest};
      b {
        margin-right: 0.5rem;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: left;
      }
    }
  }
`
